export const GET_CHART_DATA = "get chart data"
export const GET_CHART_DATA_SUCCESS = "get chart data success"
export const GET_CHART_DATA_FAILURE = "get chart data failure"

export const FETCH_VESSELS = "fetch inspections"
export const FETCH_VESSELS_SUCCESS = "fetch inspections success"
export const FETCH_VESSELS_FAILURE =  "fetch inspections failure"

export const GET_SHIPYARD_CHART_DATA = "get shipyard chart data"
export const GET_SHIPYARD_CHART_DATA_SUCCESS = "get shipyard chart data success"
export const GET_SHIPYARD_CHART_DATA_FAILURE = "get shipyard chart data failure"

export const  FETCH_SERVICE_VESSELS = "Fetch Service Vessels"
export const  FETCH_SERVICE_VESSELS_SUCCESS = "Fetch Service Vessels Success"
export const  FETCH_SERVICE_VESSELS_FAILURE = "Fetch Service Vessels Failure"

export const  FETCH_PRODUCTS_SERVICE_VESSELS = "Fetch Products Service Vessels"
export const  FETCH_PRODUCTS_SERVICE_VESSELS_SUCCESS = "Fetch Products Service Vessels Success"
export const  FETCH_PRODUCTS_SERVICE_VESSELS_FAILURE = "Fetch Products Service Vessels Failure"

export const  FETCH_SHIPYARD_VESSELS = "Fetch Shipyard Vessels"
export const  FETCH_SHIPYARD_VESSELS_SUCCESS = "Fetch Shipyard Vessels Success"
export const  FETCH_SHIPYARD_VESSELS_FAILURE = "Fetch Shipyard Vessels Failure"

export const FETCH_PRODUCTS = "get products"
export const GET_PRODUCTS_SUCCESS = "get products success"
export const GET_PRODUCTS_FAILURE = "get products failure"

export const CHANGE_SORTING = "change sorting"


export const getChartData = (companyId) => ({
  type: GET_CHART_DATA,
  companyId: companyId
});

export const getProductsChartData = (companyId) => ({
  type: GET_PRODUCTS_CHART_DATA,
  companyId: companyId
});

export const getShipyardChartData = (companyId) => ({
  type: GET_SHIPYARD_CHART_DATA,
  companyId: companyId
});

export const fetchShipyardVessels = (data,searchName, params) => ({
  type: FETCH_SHIPYARD_VESSELS,
  payload: data,
  searchName:searchName,
  params:params
});

export const fetchServiceVessels = (data) => ({
  type: FETCH_SERVICE_VESSELS,
  payload: data,
  
});

export const fetctVessels = (data) => ({
  type: FETCH_VESSELS,
  payload: data
});

export const fetchProductsServiceVessels = (data,searchName, params) => ({
  type: FETCH_PRODUCTS_SERVICE_VESSELS,
  payload: data,
  searchName:searchName,
  params:params
});

export const fetchProducts = (data,searchName, params) => ({
  type: FETCH_PRODUCTS,
  payload: data,
  searchName:searchName,
  params:params
});

export const changeSorting = (sortBy) => ({
  type: CHANGE_SORTING,
  sortBy: sortBy
});

